import sortBy from 'lodash/sortBy'
import {
  operations,
  client,
  Ok,
  HttpError,
  handleDataOrError,
} from '@freckle/educator-entities/ts/fancy-api-client'

export type CourseAttrs = Ok<operations['getCoursesR']>[0]

export const patchHideCourse = (courseId: number, hidden: boolean): Promise<void> =>
  client
    .PATCH('/2/courses/{CourseR-CourseId}', {
      params: {path: {'CourseR-CourseId': courseId}},
      body: {hidden},
    })
    .then(({response}) => {
      if (!response.ok) return Promise.reject(new HttpError(response))
    })

/**
 * Utilities
 */

export const isCourseActive = (course: Pick<CourseAttrs, 'archived' | 'hidden'>): boolean =>
  !isCourseHidden(course) && !isCourseArchived(course)

export const isCourseHidden = (course: Pick<CourseAttrs, 'hidden'>): boolean => course.hidden

export const isCourseArchived = (course: Pick<CourseAttrs, 'archived'>): boolean => course.archived

export const doesCourseHaveSisId = (course: Pick<CourseAttrs, 'sisId'>): boolean =>
  course.sisId !== null

export const fetchCourses = (): Promise<Array<CourseAttrs>> =>
  client
    .GET('/2/courses')
    .then(handleDataOrError)
    .then(courses => sortBy(courses, course => course.id))

export const fetchSchoolCourses = (schoolId: number): Promise<Array<CourseAttrs>> =>
  client
    .GET('/2/schools/{SchoolP-SchoolId}/courses', {params: {path: {'SchoolP-SchoolId': schoolId}}})
    .then(handleDataOrError)
    .then(courses => sortBy(courses, course => course.id))

export type PatchParams = NonNullable<
  operations['patchCourseR']['requestBody']
>['content']['application/json']

export const patchCourse = (courseId: number, params: PatchParams): Promise<CourseAttrs> =>
  client
    .PATCH('/2/courses/{CourseR-CourseId}', {
      params: {path: {'CourseR-CourseId': courseId}},
      body: params,
    })
    .then(handleDataOrError)

export const deleteCourse = (courseId: number) =>
  client.DELETE('/2/courses/{CourseR-CourseId}', {params: {path: {'CourseR-CourseId': courseId}}})
